import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const initialState = {
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations, getters } as IStore<IModuleState>;
